//import BannerImage from '../images/front3.jpg';

export default function Banner(){
    return(
        <div className="banner-container">
            <div className="banner-main">
                 <h1>Fast and Safety</h1>
                 <h1 style={{fontWeight: "bolder",fontSize: "60px"}}>3 Keys Logistics Limited</h1>
                 <h1>World Wide Services</h1>
                 <h1 className="banner-text-outline">Provider</h1>
                 <span>With More than 30 years experience in the logistics industry</span>
                 <br /><br />
            </div>
        </div>
    );
}